module.exports = __webpack_public_path__ + "fonts/fa-solid-900.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-solid-900.ttf
// module id = 55
// module chunks = 0